import { Navigate } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const EmployeePrivateRouter = ({children}) => {
    const token = localStorage.getItem("jwt")

    if (!token) {
        return <Navigate to="/" />
    }

    try {
        const decoded = jwtDecode(token)

        if (decoded.exp * 1000 < Date.now()) {
            localStorage.removeItem("jwt")
            return <Navigate to="/" />
        }

        if (decoded.rol === "employee") {
            return children
        }

        return <Navigate to="/" />
    } catch (err) {
        return <Navigate to="/" />
    }
}

export default EmployeePrivateRouter